import { createActions } from '../utils/actions';

const { actions: billingV3 } = createActions('billingV3')
  .add('cleanUp')
  .addAsync('getCustomer')
  .add('getInvoices')
  .add('getShops')
  .addAsync('getShop')
  .addAsync('manageShop')
  .addAsync('setInvoicesTab')
  .add('setData')
  .add('togglePaymentMethodModal');

export default billingV3;
